// @ts-strict-ignore
import { HubbleProvider } from "@hubble/web";
import React from "react";

export const ContentfulThemeProvider = (props) => {
  const { theme, children } = props;
  return Boolean(theme) ? (
    <HubbleProvider scheme={theme}>{children}</HubbleProvider>
  ) : (
    <React.Fragment>{children}</React.Fragment>
  );
};
